import { render } from "./Trxtk.vue?vue&type=template&id=01e69914&scoped=true"
import script from "./Trxtk.vue?vue&type=script&lang=js"
export * from "./Trxtk.vue?vue&type=script&lang=js"

import "./Trxtk.vue?vue&type=style&index=0&id=01e69914&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01e69914"]])

export default __exports__